import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  sync(event) {
    const [data, _status, _xhr] = event.detail
    if (!data.id) return

    const newValue = this.element.querySelector('select')?.value || ""

    // Find all server selects for this reservation and sync them
    document.querySelectorAll(`[data-server-sync-reservation-id="${data.id}"] select`).forEach(select => {
      if (select !== this.element.querySelector('select')) {
        select.value = newValue
      }
    })
  }
}
